export enum Alignment {
  CENTER = 'center',
  LEFT = 'left'
}

type TextTheme = 'light' | 'dark'

export type M0041Props = {
  /** Optional text alignment, defaults to center */
  alignment?: Alignment
  textAlignment?: Alignment
  /** Optional background image url */
  backgroundImageUrl?: string
  /** Optional color overlay for the component */
  colorOverlay?: string
  /** Required text to be displayed as the heading */
  heading: string
  /** Optional prop to check if there is a voucherCode - defaults to false */
  hasVoucherCode?: boolean
  /**  Optional text theme - defaults to light */
  textTheme?: TextTheme
  /** Option of opening in a new tab, defaults to an empty string  */
  linkTarget?: '' | '_blank' | '_self'
  /** Optional link title, can be seen when hovering over the component */
  linkTitle?: string
  /** Optional URL */
  linkUrl?: string
  /** Optional subheading text */
  subheading?: string
  /** Optional voucher code text */
  voucherCode?: string
  /** Optional legalCopy text for more information regarding the voucher code */
  legalCopy?: string
  /** Optional function to handle click */
  onLinkClick?: (event?: React.MouseEvent<HTMLElement>, url?: string) => void
  type: string
  /** Information about parent type */
  consumingGridType?: string
  /** Optional position number populated when the component is used within a grid */
  positionInGrid?: number
  /** Optional link object */
  link?: {
    /** Link URL */
    url: string
    /** Link title, can be seen when hovering over the component  */
    title: string
    /** Optional link target: option of opening in a new tab, defaults to an empty string */
    target?: '' | '_blank' | '_self'
  }
}

export type M0041StyledProps = {
  colorOverlay?: string
  backgroundImage?: string
  textAlignment?: Alignment
}

export type M0041StyledVoucher = M0041StyledProps & {
  hasVoucherCode: boolean
  textTheme: TextTheme
}

export type StyledHeroCopyWrapperProps = {
  hasLegalCopy: boolean
  textAlignment: Alignment
  textTheme: TextTheme
}
